import{noop as o}from"./noop.mjs.js";let m=o,p=o;export{p as invariant,m as warning};
